import EventBus from "./event-bus";
import {errorHandler} from "./common";

const axios = require('axios');

export function updateOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/order', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateOrderSummary(order) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/order/summary', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeOrder(id, query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/order/' + id + '/change?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateOrderItem(orderItem) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/order/item', JSON.stringify(orderItem), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateMethod(order) {
  return new Promise(function (resolve, reject) {
    console.log("Assign driver ");
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/order/method', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error);
      });
  })
}
export function assignDriver(orderId, driverId) {
  return new Promise(function (resolve, reject) {
    console.log("Assign driver ");
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'driver/order/assign/driver?orderId='+orderId + '&driverId='+driverId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
      reject(error);
      });
  })
}
export function addMemo(memo) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/note', JSON.stringify(memo), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Memo");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeItemAmount(item) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/order/item/modify', JSON.stringify(item), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteMemo(id) {
  return new Promise(function (resolve, reject) {
    console.log("Delete memo ")
    EventBus.$emit("showLoading", true);
    axios.delete(process.env.ROOT_API + 'admin/note?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function changeOrderDate(orderId, date) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/reportDate?id='+orderId + '&date=' + date, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item completed");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function completeOrder(orderId, sendInvoice) {
  return new Promise(function (resolve, reject) {
    console.log("complete order ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/complete?id='+orderId + "&invoice=" + sendInvoice, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("Order Item completed");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function uncompleteOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/order/uncomplete?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item completed");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("retrieve order " + orderId);
    axios.get(process.env.ROOT_API + 'admin/order?orderId=' + orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("retrieve order");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function setOrderDriver(orderId, driverId) {
  return new Promise(function (resolve, reject) {
    // console.log("retrieve order " + orderId);
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/'+orderId +'/driver/assign/' + driverId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      // console.log("retrieve order");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function searchOrder(invoice, prefix = 'INV') {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/orders/search/invoice?invoice=' + invoice + '&prefix=' + prefix, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function refreshOrder(orderId) {
  return new Promise(function (resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/refresh?orderId=' + orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrderItemTracking(itemId) {
  return new Promise(function (resolve, reject) {

    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/item/' + itemId + '/tracking', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getUnpaidOrder(merchantId, query = null) {
  return new Promise(function (resolve, reject) {
    console.log("get unpaid list now ")
    // console.log(process.env.ROOT_API + 'admin/orders/unpaid?merchantId=' + merchantId);
    // console.log("X-AUTH-TOKEN" + " " + localStorage.getItem("JSTOKEN"));
    let url = process.env.ROOT_API + 'admin/orders/unpaid?merchantId=' + merchantId;
    if(query !== null && query.length > 0) {
      url += '&' + query;
    }
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("unpaid list");
      // console.log(data);
      resolve(data);
    })
    .catch(error => {
      console.log("error to update");
      console.log(error.response);
      errorHandler(error);
      reject(error)
    });
  })
}

export function queryOrders(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/orders?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrderReport(query) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/orders/report?' + query, {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}

export function getOrderListExcel(query) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/orders/list/excel?' + query, {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function getProductOrderList(merchantId, deliveryDate) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/orders/list?merchantId=' + merchantId + "&deliveryDate=" + deliveryDate, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function confirmOrderItem(orderId, full = true) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/item/confirm?id='+orderId +"&full="+full, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function cancelOrderItem(orderId, full = true) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/item/cancel?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function cancelOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/cancel?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function confirmOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/confirm?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function invoiceOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/invoice?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function invoiceOrderRegenerate(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/order/invoice/regenerate?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("get product Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function sendInvoiceOrder(orderId, sendTo = '') {
  return new Promise(function (resolve, reject) {
    console.log("Send Invoice ")
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/order/send/invoice?id='+orderId;
    if(sendTo != null && sendTo.length > 0) {
      url += '&sendTo=' + sendTo;
    }
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function queryOrdersItems(query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'orders/items/query?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function placeMerchantOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("place Order " + localStorage.getItem("JSTOKEN"))
    console.log(order);
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/merchant/order', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        reject(error);
      });
  })
}

export function deleteOrder(id) {
  return new Promise(function (resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/order?orderId='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Deleted");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject(error);
      });
  })
}
export function getInvoice(orderId) {
  let axiosConfig = {
    method: 'get',
    responseType: 'blob',
    url: process.env.ROOT_API + 'test/invoice?orderId='+orderId,
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {

      resolve(response);
    }).catch(function(error) {
      errorHandler(error);
      reject(error)
    });
  })
}
export function getDeliveryNote(orderId, skipIfDelivered) {
  let axiosConfig = {
    method: 'get',
    // responseType: 'blob',
    url: process.env.ROOT_API + 'admin/order/deliveryNote?orderId='+orderId + '&check=' + skipIfDelivered,
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response.data);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}

export function queryOrderItemStatement(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/statement/item/list?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrderItemSummaryPDF(report) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/item/pdf', JSON.stringify(report), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrderItemSummaryExcel(report) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/item/excel', JSON.stringify(report), {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);


      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function queryMerchantPerformance(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/performance/merchants?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getPerformanceStatementExcel(report, showBreakdown = false) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/performance/merchants/excel?showBreakdown=' + showBreakdown, JSON.stringify(report), {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function queryOrderStatement(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/statement/order?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function sendOrderStatementPDF(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/statement/order/send?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getOrderStatementPDF(report, showCost, summary) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/summary/pdf?showCost=' + showCost + '&summary='+summary,  JSON.stringify(report), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];

      resolve(data);
    })
    .catch(error => {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}
export function getOrderStatementExcel(report, showCost) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/statement/order/excel?showCost=' + showCost, JSON.stringify(report), {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function downloadInvoice(orderId) {

}

export function createNewOrder() {
  return {
    id:0,
    merchantId:0,
    deliveryDate:'',
    state: 0,
    totalPrice:0,
    taxRate:0,
    tax:0,
    finalDue:0,
    list: []
  }
}
export function newChildOrder(product) {
  let imageUrls = []
  if(product.imageUrls.length > 0){
    imageUrls.push(product.imageUrls[0])
  }

  let item = {
    id:0,
    productId: product.id,

    merchantPrice: product.sourcePrice,
    price: product.sourcePrice,
    amount: 1,

    title: product.title,
    originalPrice: product.sourcePrice,
    totalPrice: product.sourcePrice,
    taxRate:product.taxRate,
    tax: product.sourcePrice *  product.taxRate / 10000,
    useVariablePrice: product.useVariablePrice,
    variablePriceAmount:0,
    variablePriceAmountFloat:0.0,
    variablePriceUnit: product.variablePriceUnit,

    description: product.description,

    imageUrls: imageUrls
  };

  item.finalDue = item.totalPrice + item.tax;

  return item;
}
export function getOrderStateList() {
  let list = [
    {
      state: 0,
      title: 'Ordered',
      selected:false,
      btnTitle:"Received",
      icon:'/static/img/ic_order_received.svg',
      progress:true,
    },
    {
      state: 10,
      title: 'Accepted',
      selected:false,
      progress:false,
    },
    {
      state: 18,
      title: 'Picking Confirmed',
      selected:false,
      progress:false,
    },
    {
      state: 20,
      title: 'Confirmed',
      selected:false,
      btnTitle:"Confirm",
      icon:'/static/img/ic_order_confirmed.svg',
      progress:true,
    },
    {
      state: 30,
      title: 'Invoiced',
      selected:false,
      btnTitle:"Invoiced",
      icon:'/static/img/ic_order_invoiced.svg',
      progress:true,
    },
    {
      state: 40,
      title: 'Loaded',
      selected:false,
      progress:false,
    },
    {
      state: 50,
      title: 'On Mode',
      selected:false,
      progress:false,
    },
    {
      state: 60,
      title: 'Delivered',
      selected:false,
      progress:false,
    },
    {
      state: 100,
      title: 'Completed',
      selected:false,
      btnTitle:"Completed",
      icon:'/static/img/ic_order_completed.svg',
      progress:true,
    },
    {
      state: -10,
      title: 'Rejected',
      selected:false,
      progress:false,
    },
    {
      state: -20,
      title: 'Cancelled',
      selected:false,
      progress:false,
    },
    {
      state: -30,
      title: 'Returned',
      selected:false,
      progress:false,
    },
    {
      state: -40,
      title: 'Refunded',
      selected:false,
      progress:false,
    },
  ];
  return list;
}



// WEBPACK FOOTER //
// ./src/api/order.js